<template>
  <slot v-if="productResponse" :breadcrumbResponse :productResponse>
    <PdpErrorBoundary>
      <ErrorOwners :owners="['bot-squad-search-and-recommendation-front']">
        <Breadcrumb
          v-if="breadcrumbResponse"
          :breads="[
            ...breadcrumbResponse.breadcrumb,
            { label: productResponse?.titles?.default, url: route.path },
          ]"
          class="bg-surface-default-low hidden md:block"
          trackingZone="product"
        />
        <!-- 24px height + 20px vertical padding = 64px -->
        <div v-else-if="breadcrumbPending" class="max-md:hidden py-20">
          <RevSkeleton height="24px" shape="rectangle" width="50%" />
        </div>
      </ErrorOwners>
    </PdpErrorBoundary>
    <div
      class="flex flex-wrap justify-between gap-x-8 pb-8 ps-24 md:hidden md:p-0 md:ps-0"
    >
      <BreadcrumbProductPage
        v-if="breadcrumbResponse"
        :breads="breadcrumbResponse.breadcrumb"
        class="bg-surface-default-low"
        trackingZone="product"
      />

      <!-- 32px height + 8px vertical margins = 48px -->
      <RevSkeleton
        v-else-if="breadcrumbPending"
        class="my-8"
        height="32px"
        shape="rectangle"
        width="50%"
      />
    </div>
  </slot>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import ErrorOwners from '@backmarket/nuxt-module-logger/components/ErrorOwners.vue'
import { RevSkeleton } from '@ds/components/Skeleton'

import Breadcrumb from '~/scopes/navigation/components/Breadcrumb/Breadcrumb.vue'
import BreadcrumbProductPage from '~/scopes/product-core/components/presentationals/Breadcrumb/Breadcrumb.vue'
import PdpErrorBoundary from '~/scopes/product-core/components/presentationals/PdpErrorBoundary/PdpErrorBoundary.vue'
import { useFetchBreadcrumb } from '~/scopes/product-core/composables/useFetch/useFetchBreadcrumb/useFetchBreadcrumb'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: breadcrumbResponse, pending: breadcrumbPending } =
  useFetchBreadcrumb()
const { data: productResponse } = useFetchProduct()

const route = useRoute()
</script>
